import z from 'zod'

export const amPointSchema = z.object({
  type: z.literal('Point'),
  coordinates: z.number().array().length(2),
})

export type AMPoint = z.infer<typeof amPointSchema>

export const amDateShema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/)

export const amMobilityDateRangeSchema = z.object({
  from: amDateShema,
  to: amDateShema,
})
export type AMMobilityDateRange = z.infer<typeof amMobilityDateRangeSchema>

export type AMDate = z.infer<typeof amDateShema>

export enum amDaysEnum {
  monday = 'monday',
  tuesday = 'tuesday',
  wednesday = 'wednesday',
  thursday = 'thursday',
  friday = 'friday',
  saturday = 'saturday',
  sunday = 'sunday',
}

export const amDayShema = z.nativeEnum(amDaysEnum)

export type AMDay = z.infer<typeof amDayShema>
